<template>
  <div class="container" v-if="gameStarted && !showQuestionTypeButtons && !showDonationScreen">
    <img :src="'/images/' + (question.type === 'truth' ? 'truth_top' : 'juicy_top') + '.webp'"
         :class="['responsive-img', 'top-image', question.type === 'truth' ? 'truth-top' : 'juicy-top']"
         alt="question type top" width="400">
    <div class="row top top-game">
      <img :src="'/images/' + (question.type === 'truth' ? 'truth_title' : 'juicy_title') + '.webp'" alt="question type"
        :class="['question-title-img', question.type === 'truth' ? 'truth-title-img' : 'juicy-title-img']">
      <h2 class="question">{{ question.question }}</h2>
      <div class="go-deeper" v-if="question.deeper_question" :class="{ revealed: deeperRevealed }" @click="goDeeper" v-track-click="'go_deeper'">
        Go Deeper
        <i class='bx bx-chevron-up chevron'></i>
      </div>
      <div class="deeper-container" v-if="question.deeper_question">
        <h3 class="deeper-text deeper-text-spacing" :class="[deeperRevealed ? 'visible' : 'hidden']">
          {{ question.deeper_question }}
        </h3>
      </div>
    </div>
    <div class="row bottom">
      <!-- Empty bottom row since elements are now fixed positioned -->
    </div>

    <!-- Fixed positioned elements outside of flex container -->
    <div class="next-button" @click="nextQuestion" v-track-click="'next_question'">
      <img src="/images/next_question_btn.webp" alt="Next Question" width="200" height="80" class="responsive-img">
    </div>
    <div class="feedback-buttons">
      <div class="like-button" @click="likeQuestion" :class="{ active: liked && !disliked }" v-track-click="'like_button'">
        <i v-if="liked && !disliked" class="bx bxs-heart"></i>
        <i v-else class="bx bx-heart"></i>
      </div>
      <h3 class="opinion-text">Do you like this question?</h3>
      <div class="dislike-button" @click="dislikeQuestion" :class="{ active: disliked && !liked }" v-track-click="'dislike_button'">
        <i v-if="disliked && !liked" class="bx bxs-x-circle"></i>
        <i v-else class="bx bx-x-circle"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from '../store';
import { mapState, mapActions } from 'pinia';

export default {
  computed: {
    ...mapState(useStore, [
      'gameStarted',
      'showQuestionTypeButtons',
      'showDonationScreen',
      'question',
      'deeperRevealed',
      'liked',
      'disliked',
    ]),
  },
  methods: {
    ...mapActions(useStore, ['goDeeper', 'nextQuestion', 'likeQuestion', 'dislikeQuestion']),
  },
};
</script>

<style scoped>
.top-game {
    justify-content: flex-start;
    margin-top: 11vh;
    padding-top: 11vh;
    padding-bottom: 30vh;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.truth-top {
    position: absolute;
    top: -30px;
    left: 30%;
    width: 70vw;
    height: 35vh;
    transform: translateX(-50%);
    z-index: 1;
}

.juicy-top {
    position: absolute;
    top: 0px;
    width: 150%;
    height: 45vh;
    left: 7%;
    transform: translateX(-50%);
    z-index: 1;
}

.question {
    margin: 0px 35px 50px 35px;
    font-size: 1.5em;
}

.next-button {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: transform 0.2s ease;
    background: transparent;
    border: none;
    padding: 0;
    position: fixed;
    bottom: 20vh;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
}

.next-button:active {
    transform: translateX(-50%) scale(0.95);
}

.next-button img {
    max-width: 100%;
    height: auto;
}

.feedback-buttons {
    color: var(--raspberry-pink);
    display: flex;
    flex-direction: row;
    padding-top: 10vh;
    width: 100%;
    height: 20vh;
    position: fixed;
    bottom: -6vh;
    left: 0;
    right: 0;
    margin-top: 0;
}

.dislike-button,
.like-button {
    position: absolute;
    color: var(--raspberry-pink);
    font-size: 40px;
    cursor: pointer;
    transform: translateY(10%);
}

.dislike-button {
    top: 50%;
    right: 10%;
    font-size: 44px;
}

.like-button {
    top: 50%;
    left: 10%;
    font-size: 44px;
}

.opinion-text {
    color: var(--raspberry-pink);
    position: absolute;
    bottom: 25%;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    max-width: 50%;
}

.go-deeper {
    order: 3;
    font-size: 26px;
    text-shadow:
        0.5px 0 0 currentColor,
        1px 0 0 currentColor,
        1.5px 0 0 currentColor;
    color: var(--raspberry-pink);
}

.deeper-text {
    border-radius: 10px;
    border-width: 3px;
    border-style: solid;
    border-color: var(--raspberry-pink);
    padding: 8px;
    transition: opacity 0.3s ease;
    max-width: 70%;
    margin: 0 auto;
    font-size: 1.3em;
    line-height: 1.4;
}

.deeper-text.visible {
    visibility: visible;
    opacity: 1;
}

.deeper-text.hidden {
    visibility: hidden;
    opacity: 0;
}

.chevron {
    display: inline-block;
    transition: transform 0.3s ease;
    transform: rotate(180deg);
}

.revealed .chevron {
    transform: rotate(0deg);
}

.feedback-buttons .like-button.active i {
    color: var(--raspberry-pink);
}

.feedback-buttons .dislike-button.active i {
    color: var(--raspberry-pink);
}

.question-title-img {
    width: 220px;
    height: 66px;
    object-fit: contain;
}

.truth-title-img {
    margin-bottom: 5px;
    width: 130px;
}

.juicy-title-img {
    margin-bottom: 15px;
}

.deeper-text-spacing {
    margin-bottom: 20px;
}

.deeper-container {
    order: 4;
}

.container {
    display: flex;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
}

.row {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 50%;
}

.top {
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
}

.bottom {
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;
}

.responsive-img {
    max-width: 100%;
    height: auto;
}
</style>
